import { graphql } from 'react-relay';

import { commit } from '../../mutations/commit';

const mutation = graphql`
  mutation createCashbackMutation($input: CreateCashbackInput!) {
    createCashback(input: $input) {
      cashback {
        id
      }
      errorMessage
    }
  }
`;

const createCashback = (environment, attributes, args = {}) => {
  return commit(environment, {
    mutation,
    variables: {
      input: attributes,
    },
    ...args,
  });
};

export default createCashback;
